import { createFileRoute } from '@tanstack/react-router'

import { SalesActivityScreen } from './-components/activity-screen.tsx'

export const Route = createFileRoute('/sales/activity')({
  component: SalesActivityScreen
})
